/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {Link, Switch, Redirect, matchPath, useHistory} from "react-router-dom";
import {toAbsoluteUrl} from "../../../../_metronic/_helpers";
import {ContentRoute} from "../../../../_metronic/layout"
import Login from "./Login";
import Registration from "./Registration";
import ForgotPassword from "./ForgotPassword";
import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";
import ForgotPasswordVerify from "./ForgotPasswordVerify";
import AccountValidate from "./AccountValidate";
import ReactGA from 'react-ga4';

ReactGA.initialize('G-EQXLSSMRQT')
export function AuthPage() {
    let history = useHistory();
    const match = matchPath(history.location.pathname, {
        // You can share this string as a constant if you want
        path: "/auth/login"
    });
    const dt = new Date();
    const year = dt.getFullYear();
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search, title: window.location.title });
    return (
        <>
            <div className="d-flex flex-column flex-root">
                {/*begin::Login*/}
                <div
                    className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white"
                    id="kt_login"
                >
                    <div
                        className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10"
                        style={{
                            backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-4.jpg")})`
                        }}
                    >
                        {/*begin: Aside Container*/}
                        <div className="d-flex flex-row-fluid flex-column justify-content-between">
                            {/* start:: Aside header */}
                            <a href="https://saledrum.com" className="flex-column-auto mt-5">
                                <img
                                    alt="Logo"
                                    className="max-h-200px"
                                    src="/media/logos/saledrum-logo.png"
                                />
                            </a>
                            {/* end:: Aside header */}

                            {/* start:: Aside content */}
                            <div className="flex-column-fluid d-flex flex-column justify-content-center">
                                <h3 className="font-size-h1-xxl mb-5 text-white">
                                    Seamless price optimization
                                </h3>
                                <p className="font-weight-lighter text-white opacity-80 font-size-h1">
                                    Boost your revenue effortlessly using automated pricing rules
                                </p>
                            </div>
                            {/* end:: Aside content */}

                        </div>
                        {/*end: Aside Container*/}
                    </div>

                    {/*begin::Content*/}
                    <div className="login-content flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden">
                        {/*begin::Content header*/}
                        <div className="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">
                            {match && <>
                                <span className="font-weight-bold text-dark-50">Don't have an account yet?</span>
                                <Link to="/auth/registration" className="font-weight-bold ml-2" id="kt_login_signup">Sign Up!</Link></>}
                            {!match && <>
                                <span className="font-weight-bold text-dark-50">Have an account?</span>
                                <Link to="/auth/login" className="font-weight-bold ml-2" id="kt_login_signup">Log In!</Link></>}
                        </div>
                        {/*end::Content header*/}

                        {/* begin::Content body */}
                        <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
                            <Switch>
                                <ContentRoute path="/auth/login" component={Login}/>
                                <ContentRoute path="/auth/registration" component={Registration}/>
                                <ContentRoute path="/auth/forgot-password-verify/:password_token" component={ForgotPasswordVerify}/>
                                <ContentRoute path="/auth/account-validate/:password_token" component={AccountValidate}/>
                                <ContentRoute
                                    path="/auth/forgot-password"
                                    component={ForgotPassword}
                                />
                                <Redirect from="/auth" exact={true} to="/auth/login"/>
                                <Redirect to="/auth/login"/>
                            </Switch>
                        </div>
                        {/*end::Content body*/}
                        {/* start:: Aside footer for desktop */}
                        <div className="d-none flex-column-auto d-lg-flex justify-content-between mt-10">
                            <div className="d-flex">
                                <a href="https://saledrum.com/privacy" className="text-black">
                                    Privacy Policy
                                </a>
                                <a href="https://saledrum.com/terms" className="text-black ml-10">
                                    Terms and Conditions
                                </a>
                                <a href="https://saledrum.com/contact" className="text-black ml-10">
                                    Contact
                                </a>
                            </div>

                                <div className="opacity-70 font-weight-bold	text-black" style={{marginRight: 100}}>
                                    &copy; {year} SaleDrum.com
                                </div>
                        </div>
                        {/* end:: Aside footer for desktop */}
                        {/* begin::Mobile footer */}
                        <div
                            className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
                            <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
                                &copy; {year} SaleDrum
                            </div>
                            <div className="d-flex order-1 order-sm-2 my-2">
                                <a href="https://saledrum.com/privacy" className="text-white">
                                    Privacy Policy
                                </a>
                                <a href="https://saledrum.com/terms" className="text-white ml-10">
                                    Terms and Conditions
                                </a>
                                <a href="https://saledrum.com/contact" className="text-white ml-10">
                                    Contact
                                </a>
                            </div>
                        </div>
                        {/* end::Mobile footer */}
                    </div>
                    {/*end::Content*/}
                </div>
                {/*end::Login*/}
            </div>
        </>
    );
}
